export default function AboutDetail() {
  return (
    <section className="bg-[#E9E3D5] min-h-screen flex flex-col items-center text-[#2D435B] font-[Poppins]">
      {/* === WHO WE ARE === */}
      <div className="w-full px-[5vw] py-8 sm:py-10 md:py-14 flex justify-center">
        <div className="w-full max-w-[1400px]">
          <h1
            className="font-extrabold mb-6 sm:mb-10 md:mb-14 text-left leading-tight
                       text-[1.3rem] sm:text-[2.5rem] md:text-[5rem] lg:text-[6rem]"
          >
            Who We Are
          </h1>

          {/* === TEKS UTAMA === */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-8 md:gap-12 w-full">
            <p
              className="leading-relaxed text-justify
                         text-[0.65rem] sm:text-[0.85rem] md:text-[1rem] lg:text-[1.05rem]"
            >
              PT Asri Mandiri Kreasindo adalah konsultan struktur dengan pengalaman
              lebih dari 13 tahun dalam merancang berbagai jenis bangunan seperti
              gedung bertingkat, jembatan, hingga dermaga. Dikelola oleh tenaga ahli
              bersertifikasi, kami berkomitmen menghadirkan desain struktur yang
              aman, efisien, dan inovatif untuk setiap proyek yang kami tangani.
            </p>

            <p
              className="leading-relaxed text-justify
                         text-[0.65rem] sm:text-[0.85rem] md:text-[1rem] lg:text-[1.05rem]"
            >
              Sebagai anggota TPA Jakarta Barat & Pulau Seribu dengan sertifikat SKK
              grade 9, Asri Mandiri Kreasindo telah berpartisipasi dalam berbagai
              proyek berskala besar di seluruh Indonesia. Dengan keahlian teknis dan
              dedikasi tinggi, kami terus berupaya meningkatkan efisiensi serta
              kualitas hasil kerja di bidang teknik sipil dan bangunan.
            </p>
          </div>
        </div>
      </div>

      {/* === PEMISAH === */}
      <div className="w-full border-t-2 border-[#2D435B]/30 my-2 sm:my-4 md:my-6"></div>

      {/* === TEAM SECTION === */}
      <div className="w-full bg-[#E9E3D5] px-[4vw] py-6 sm:py-8 md:py-10 flex flex-col items-center">
        <div className="w-full max-w-[1400px] text-center">
          <h2
            className="font-bold mb-1 sm:mb-3 md:mb-5 leading-tight 
                       text-[1.5rem] sm:text-[2.5rem] md:text-[4.5rem] lg:text-[5.5rem]"
          >
            Team
          </h2>
          <p
            className="text-[#2D435B]/80 mb-4 sm:mb-6 md:mb-8 
                       text-[0.65rem] sm:text-[0.85rem] md:text-[1rem]"
          >
            Meet Our Experts
          </p>

          {/* === LIST TIM === */}
          <div
            className="grid grid-cols-3 gap-2 sm:gap-4 md:gap-8 
                       justify-items-center w-full"
          >
            {[
              {
                name: "Ricky Pasaribu",
                role: "Direktur Utama dan Tenaga Ahli Stuktur",
                phone: "+6282123235368",
                image: "/t2.png",
              },
              {
                name: "Ari Sigit Saryono",
                role: "Komisaris dan Tenaga Ahli Stuktur",
                phone: "+628568782739",
                image: "/t1.png",
              },
              {
                name: "Mohammad Haris",
                role: "Tenaga Ahli Stuktur",
                phone: "+6285718007632",
                image: "/t3.png",
              },
            ].map((person, index) => (
              <div
                key={index}
                className="flex flex-col items-center bg-white rounded-xl shadow-md
                           transition-transform hover:scale-105
                           w-[90px] sm:w-[140px] md:w-[220px] lg:w-[260px]
                           h-[180px] sm:h-[250px] md:h-[330px] lg:h-[360px]
                           pt-3 sm:pt-4 pb-2 sm:pb-3 px-2 sm:px-3"
              >
                {/* FOTO */}
                <div
                  className="overflow-hidden mb-2 sm:mb-3 flex items-center justify-center
                             w-[55px] sm:w-[80px] md:w-[110px] lg:w-[120px]
                             h-[70px] sm:h-[100px] md:h-[130px] lg:h-[140px]"
                >
                  <img
                    src={person.image}
                    alt={person.name}
                    className="w-full h-full object-contain object-top"
                  />
                </div>

                {/* NAMA & ROLE */}
                <h3
                  className="font-semibold text-center leading-snug
                             text-[0.6rem] sm:text-[0.8rem] md:text-[1.1rem]"
                >
                  {person.name}
                </h3>
                <p
                  className="text-[#2D435B]/70 text-center mb-1 sm:mb-2 px-1
                             text-[0.55rem] sm:text-[0.75rem] md:text-[0.9rem]"
                >
                  {person.role}
                </p>

                {/* NOMOR TELEPON */}
                <a
                  href={`https://wa.me/${person.phone.replace(/\D/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#2D435B] hover:underline
                             text-[0.55rem] sm:text-[0.75rem] md:text-[0.9rem]"
                >
                  {person.phone}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
